import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import useMessage from '../../util/useMessage';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../ui/SubmitButton';
import DateInput from '../../ui/DateInput';
import EnumSelect from '../../ui/EnumSelect';
import InputText from '../../ui/InputText';

import paramTipiEnum from '../../enum/paramTipiEnum';
import SwitchInput from '../../ui/SwitchInput';
import MonthYearInput from '../../ui/MonthYearInput';
import useGlobal from '../../util/Global';
import SGKMasterParameterservice from '../../service/MasterServices/SGKMasterParameterService';

const SGKMasterParameterCrudDialog = ({ open, onClose, data, crudTip, title }) => {

  const { t } = useGlobal();
  const showMessage = useMessage();
  const [crudtitle, SetCrudtitle] = useState("");

  const [paramTipi, setParamTipi] = useState(null);

  const inputObject = {
    id: data?.id,
    paramterName: data?.paramterName,
    paramKey: data?.paramKey,
    paramTipi: data?.paramTipi,
    value: data?.value,
    aciklama: data?.aciklama,
  };

  const { handleSubmit, control, reset, formState: { errors }, setValue } = useForm({
    defaultValues: {
      ...inputObject
    }
  });


  useEffect(() => {
    if (open) {
      reset({
        ...inputObject
      });

      setLoading(false);
      setStatusUpdated(false);
      if (crudTip === "Create") {
        SetCrudtitle(title + " " + t("button.add"));
        setValue("paramTipi", 1);
        setParamTipi(1);
      } else {
        setParamTipi(data?.paramTipi);
        SetCrudtitle(title + " " + t("button.update"));

        if (data.paramTipi != 4)
          setValue("value", data.value);
        else
          setValue("value", data.value == "true");
      }
    }
  }, [open, reset]);




  const [loading, setLoading] = useState(false);
  const [statusUpdated, setStatusUpdated] = useState(false);

  const Create = async (input) => {

    const { resultObject } = await SGKMasterParameterservice.create({
      paramterName: input?.paramterName,
      paramKey: input?.paramKey,
      paramTipi: input?.paramTipi,
      value: input?.value,
      aciklama: input?.aciklama,
    });
    return resultObject;
  };

  const Update = async (input) => {

    const { resultObject } = await SGKMasterParameterservice.update({
      id: data?.id,
      paramterName: input?.paramterName,
      paramKey: input?.paramKey,
      paramTipi: input?.paramTipi,
      value: input?.value,
      aciklama: input?.aciklama,
    });
    return resultObject;
  };

  const onParamChange = (value) => {
    setParamTipi(Number(value));
  }

  const onSubmit = async (input) => {
    if (loading) return false;
    try {
      setLoading(true);
      let status = false;
      if (crudTip === "Create") {
        status = await Create(input);
      } else {
        status = await Update(input);
      }
      setLoading(false);
      if (status) {
        setStatusUpdated(true);
        showMessage(t('message.created'));
      } else {
        showMessage(t('message.updateFailed'));
      }
      return status;
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const getParameterInput = (param) => {

    switch (param) {
      case 1:
        return (
          <Grid item xs={12}>
            <InputText
              name="value"
              label={t('col.value')}
              error={errors?.value}
              control={control}
              rules={{ required: t('validation.required') }}
            />
          </Grid>
        );
      case 2:
        return (
          <Grid item xs={12}>
            <InputText
              name="value"
              label={t('col.value')}
              type="number"
              error={errors?.value}
              control={control}
              rules={{ required: t('validation.required') }}
            />
          </Grid>
        );
      case 3:
        return (
          <Grid item xs={12}>
            <InputText
              name="value"
              label={t('col.value')}
              type="number"
              error={errors?.value}
              control={control}
              rules={{ required: t('validation.required') }}
            />
          </Grid>
        );

      case 4:
        return (
          <Grid item xs={12}>
            <SwitchInput
              name="value"
              label={t("col.value")}
              control={control}
              setValue={setValue}
            />
          </Grid>);
      case 5:
        return <DateInput
          name="value"
          control={control}
          label={t('value')}
          rules={{ required: t('validation.required') }}
          isDateTime={false}
        />
      case 6:
        return <DateInput
          name="value"
          control={control}
          label={t('value')}
          rules={{ required: t('validation.required') }}
          isDateTime={false}
        />
      case 7:
        return <MonthYearInput
          name="value"
          label={t('col.value')}
          control={control}
          defaultValue={data?.value}
          error={errors?.value}
          rules={{ required: t('validation.required') }}
        />
      default:
        return <Grid item xs={12}>
          <InputText
            name="value"
            label={t('col.value')}
            error={errors?.value}
            control={control}
            rules={{ required: t('validation.required') }}
          />
        </Grid>; // Add a default case to handle unexpected values
    }
  }

  const InputForm = () => {
    return (
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12}>
          <InputText
            name="paramterName"
            label={t('col.paramterName')}
            error={errors?.paramterName}
            control={control}
            rules={{ required: t('validation.required') }}
          />
        </Grid>

        <Grid item xs={12}>
          <InputText
            name="paramKey"
            label={t('col.paramKey')}
            error={errors?.paramKey}
            control={control}
            rules={{ required: t('validation.required') }}
          />
        </Grid>
        <Grid item xs={12}>
          <InputText
            name="aciklama"
            label={t('col.aciklama')}
            control={control}
            rules={{ required: t('validation.required') }}
          />
        </Grid>
        <Grid item xs={12}>
          <EnumSelect
            name="paramTipi"
            control={control}
            label={t('col.paramTipi')}
            rules={{ required: t('validation.required') }}
            StatusEnum={paramTipiEnum}
            onChange={onParamChange}
          />
        </Grid>

        {getParameterInput(paramTipi)}

      </Grid>
    );
  };



  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      scroll="paper"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>{crudtitle}</DialogTitle>
        <DialogContent dividers style={{ display: 'flex', gap: '16px' }}>
          {InputForm()}
        </DialogContent>
        <DialogActions>
          {statusUpdated ? (
            <Button onClick={onClose} color="primary">
              {t('button.done')}
            </Button>
          ) : (
            <>
              <Button onClick={onClose} color="primary" disabled={loading}>
                {t('button.cancel')}
              </Button>
              <SubmitButton loading={loading} startIcon={<SaveIcon />}>
                {t('button.save')}
              </SubmitButton>
            </>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default React.memo(SGKMasterParameterCrudDialog);